import { StyleSheet } from 'react-native';
import { PROFILE_COLORS } from '../ProfileScreen/ProfileScreen.constants';

export const headToHeadCardStyles = StyleSheet.create({
  card: {
    marginHorizontal: 16,
    marginTop: 12,
    marginBottom: 24,
    backgroundColor: PROFILE_COLORS.card,
    borderWidth: 1,
    borderColor: PROFILE_COLORS.cardBorder,
    borderRadius: 16,
    paddingHorizontal: 16,
    paddingVertical: 14,
    gap: 12,
  },
  title: {
    fontSize: 14,
    fontWeight: '700',
    color: PROFILE_COLORS.text,
  },
  empty: {
    fontSize: 13,
    lineHeight: 18,
    color: PROFILE_COLORS.textMuted,
  },
  errorBlock: {
    gap: 10,
    alignItems: 'flex-start',
  },
  retry: {
    minHeight: 40,
    paddingHorizontal: 16,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: PROFILE_COLORS.purple,
  },
  retryPressed: { opacity: 0.85 },
  retryText: {
    fontSize: 14,
    fontWeight: '700',
    color: '#14093A',
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  name: {
    flex: 1,
    fontSize: 13,
    fontWeight: '600',
    color: PROFILE_COLORS.text,
  },
  record: {
    fontSize: 13,
    fontWeight: '800',
    fontVariant: ['tabular-nums'],
  },
});
